var navigation = {
    logout: "Cerrar Sesión",
    welcome:"Bienvenido",
    home:"Inicio",
    registerbooking:"Registrar una Reserva",
    track:"Rastrear y Canjear",
    details:"Detalles y PP. FF.",
    language:"English",
    changepass: "Cambiar Contraseña",
    reservehotel:"Reservar Hotel",
    webinar:"Training Academy"
}
module.exports = navigation
